import * as React from "react";
import styled from "@emotion/styled";

export type TableProps = {
  children:
    | [React.ReactElement<TableHeadProps>, React.ReactElement<TableBodyProps>]
    | React.ReactElement<TableRowProps>
    | React.ReactElement<TableRowProps>[]
    | any
    | any[];
} & React.HTMLAttributes<HTMLTableElement>;

export type TableHeadProps = {
  children: React.ReactElement<TableRowProps> | React.ReactElement<TableRowProps>[];
} & React.HTMLAttributes<HTMLTableSectionElement>;

export type TableBodyProps = {
  children: (boolean | React.ReactElement<TableRowProps>) | (boolean | React.ReactElement<TableRowProps>)[];
} & React.HTMLAttributes<HTMLTableSectionElement>;

export type TableRowProps = {
  children: (boolean | React.ReactElement<TableCellProps>) | (boolean | React.ReactElement<TableCellProps>)[];
} & React.HTMLAttributes<HTMLTableRowElement>;

export type TableCellProps = Record<string, any> &
  React.HTMLAttributes<HTMLTableCellElement> &
  React.TdHTMLAttributes<HTMLTableDataCellElement>;

const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const StyledTableHead = styled.thead``;

const StyledTableBody = styled.tbody``;

const StyledTableRow = styled.tr``;

const StyledTableCell = styled.td`
  border: 1px solid #000;
  padding: 5px;
  text-align: center;
`;

const Table = ({ children, ...props }: TableProps) => <StyledTable {...props}>{children}</StyledTable>;

Table.Head = ({ children, ...props }: TableHeadProps) => <StyledTableHead {...props}>{children}</StyledTableHead>;

Table.Body = ({ children, ...props }: TableBodyProps) => <StyledTableBody {...props}>{children}</StyledTableBody>;

Table.Row = ({ children, ...props }: TableRowProps) => <StyledTableRow {...props}>{children}</StyledTableRow>;

Table.Cell = ({ children, ...props }: TableCellProps) => <StyledTableCell {...props}>{children}</StyledTableCell>;


export default Table;
